import VueCharts from 'vue-chartjs';
import moment from 'moment';

const TICK_INTERVAL = 7;
const Y_TICK_INTERVAL = 5;

export default {
    extends: VueCharts.Line,
    mixins: [VueCharts.mixins.reactiveProp],
    props: ['chartData', 'interval', 'created'],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        title() {
                            return '';
                        },
                        label(tooltipItem, data) {

                            let label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {
                                label += `: ${tooltipItem.yLabel}`;
                                label += data.t.unit_request_count;
                            }
                            return label;
                        },
                        footer(tooltipItem, data) {
                            if (typeof data.labels[tooltipItem[0].index] === 'object') {
                                if (data.t.interval === '1d') {
                                    return data.labels[tooltipItem[0].index][0];
                                }
                                return data.labels[tooltipItem[0].index].join(' ');
                            }
                            return data.labels[tooltipItem[0].index];
                        },
                    },
                    bodySpacing: 5,
                    footerSpacing: 7,
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            maxRotation: 0,
                            minRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: TICK_INTERVAL,
                            callback(value, index, values) {
                                if (value.length === 2) {
                                    if (this.chart.data.t.interval === '1d') {
                                        return moment(value[0]).format('MM-DD');
                                    }
                                    const tm = value[1].split(':');
                                    tm.pop();
                                    return [moment(value[0]).format('MM-DD'), tm.join(':')];
                                }
                                if (this.chart.data.t.interval === '1d') {
                                    return moment(value).format('MM-DD');
                                }
                                return moment(value).format('MM-DD HH:mm');
                            },
                        },
                    }],
                    yAxes: [{
                        fill: false,
                        display: true,
                        ticks: {
                            min: 0,
                            maxTicksLimit: Y_TICK_INTERVAL,
                            callback(value, index, values) {
                                if (Math.floor(value) === value) {
                                    return value;
                                }
                            },
                        },
                    }],
                },
            },
        };
    },
    mounted() {
        this.addPlugin({
            beforeInit(chart) {
                chart.data.labels.forEach((e, i, a) => {
                    e = moment(e).format('YYYY-MM-DD HH:mm:ss');
                    if (/\s/.test(e)) {
                        a[i] = e.split(/\s/);
                    }
                });
            },
        });
    },
    methods: {
        initialize() {
            // this.paddingData();
            this.loadChart();
        },
        loadChart() {
            let color = Chart.helpers.color;
            this.renderChart({
                t: {
                    unit_user_count: this.$t('words.unit_user_count'),
                    unit_request_count: this.$t('words.unit_request_count'),
                    interval: this.interval,
                },
                labels: this.chartData.labels,
                datasets: [
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.response_code_1xx_desc'),
                        backgroundColor: color('#1f4047').alpha(1).rgbString(),
                        borderColor: '#1f4047',
                        borderWidth: 2,
                        data: this.chartData.results.results_1xx,
                    },
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.response_code_2xx_desc'),
                        backgroundColor: color('#2f9e44').alpha(1).rgbString(),
                        borderColor: '#2f9e44',
                        borderWidth: 2,
                        data: this.chartData.results.results_2xx,
                    },
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.response_code_3xx_desc'),
                        backgroundColor: color('#1c7ed6').alpha(1).rgbString(),
                        borderColor: '#1c7ed6',
                        borderWidth: 2,
                        data: this.chartData.results.results_3xx,
                    },
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.response_code_4xx_desc'),
                        backgroundColor: color('#f76707').alpha(1).rgbString(),
                        borderColor: '#f76707',
                        borderWidth: 2,
                        data: this.chartData.results.results_4xx,
                    },
                    {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: this.$t('words.response_code_5xx_desc'),
                        backgroundColor: color('#f03e3e').alpha(1).rgbString(),
                        borderColor: '#f03e3e',
                        borderWidth: 2,
                        data: this.chartData.results.results_5xx,
                    },
                ]
            }, this.options);
        },
        updateChart() {
            this.paddingData();
            this._data._chart.data.labels = this.chartData.labels;
            this._data._chart.data.datasets[0].data = this.chartData.results.results_1xx;
            this._data._chart.data.datasets[1].data = this.chartData.results.results_2xx;
            this._data._chart.data.datasets[2].data = this.chartData.results.results_3xx;
            this._data._chart.data.datasets[3].data = this.chartData.results.results_4xx;
            this._data._chart.data.datasets[4].data = this.chartData.results.results_5xx;
        },
        paddingData() {
            if (this.chartData.results.results_1xx.length > 0) {
                if (this.chartData.results.results_1xx[0] === 0 && this.chartData.results.results_2xx[0] === 0 && this.chartData.results.results_3xx[0] === 0
                    && this.chartData.results.results_4xx[0] === 0 && this.chartData.results.results_5xx[0] === 0
                ) {
                    // remove first item
                    this.chartData.labels = _.drop(this.chartData.labels, 1);
                    this.chartData.results.results_1xx = _.drop(this.chartData.results.results_1xx, 1);
                    this.chartData.results.results_2xx = _.drop(this.chartData.results.results_2xx, 1);
                    this.chartData.results.results_3xx = _.drop(this.chartData.results.results_3xx, 1);
                    this.chartData.results.results_4xx = _.drop(this.chartData.results.results_4xx, 1);
                    this.chartData.results.results_5xx = _.drop(this.chartData.results.results_5xx, 1);
                }
            }
            if (this.chartData.results.results_1xx.length > 0) {
                const lastIndex = this.chartData.results.results_1xx.length - 1;
                if (this.chartData.results.results_1xx[lastIndex] === 0 && this.chartData.results.results_2xx[lastIndex] === 0 && this.chartData.results.results_3xx[lastIndex] === 0
                    && this.chartData.results.results_4xx[lastIndex] === 0 && this.chartData.results.results_5xx[lastIndex] === 0
                ) {
                    // remove last item
                    this.chartData.labels = _.dropRight(this.chartData.labels, 1);
                    this.chartData.results.results_1xx = _.dropRight(this.chartData.results.results_1xx, 1);
                    this.chartData.results.results_2xx = _.dropRight(this.chartData.results.results_2xx, 1);
                    this.chartData.results.results_3xx = _.dropRight(this.chartData.results.results_3xx, 1);
                    this.chartData.results.results_4xx = _.dropRight(this.chartData.results.results_4xx, 1);
                    this.chartData.results.results_5xx = _.dropRight(this.chartData.results.results_5xx, 1);
                }
            }
        },
    },
    watch: {
        // created(newValue, oldValue) {
        //     this.paddingData();
        //     this.loadChart();
        // },
    },
}
